import styled from 'styled-components';
import Colors from 'library/constants/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 18px 40px;
  ${({ isFree }) => !isFree && `
    background: linear-gradient(
      269.5deg, 
      ${Colors.linear01}, 
      0%,
      ${Colors.linear01} 0%,
      ${Colors.linear02} 20.57%,
      ${Colors.linear03} 40.61%,
      ${Colors.linear04} 58.4%,
      ${Colors.linear05} 80.79%,
      ${Colors.linear06} 100%);
    `}
  ${({ isFree }) => isFree && `
    background-color: ${Colors.violet};
  `}
  box-shadow: 0 2px 10px rgba(45, 49, 50, 0.08);
  border-radius: 4px;
  margin-top: 10px;
`;

export const MembershipPlan = styled.h4`
  font-weight: bold;
  font-size: 18px;
  color: ${Colors.shade06};
  margin: 0 10px;
`;

export const ProPlan = styled.h3`
  font-weight: bold;
  font-size: 24px;
  color: ${Colors.shade08};
  margin: 0 10px;
`;

export const DateInfo = styled.p`
  font-size: 15px;
  color: ${Colors.shade06};
  margin: 0 10px;
`;
